import gql from 'graphql-tag';

export const CALENDAR_VIEW_CONFIGURATION_ITEM = gql`
  query CalendarViewableUsers($input: CalendarViewConfigurationItemInput!) {
    dealActivity {
      result: calendarViewConfigurationItem(input: $input) {
        error
        success
        entity {
          id
          name
          color
        }
      }
    }
  }
`;
